import { m, LazyMotion, domAnimation } from 'framer-motion'
import { useEffect, useState } from 'react'
import { ReactElement } from 'react'
import { createPortal } from 'react-dom'
import { useTransition } from '../context/TransitionContext'

function PageTransition(): ReactElement | null {
  const { isTransitioning, pageName, onTransitionComplete } = useTransition()
  const [shouldSlideUp, setShouldSlideUp] = useState(false)

  useEffect(() => {
    if (isTransitioning) {
      const slideTimer = setTimeout(() => setShouldSlideUp(true), 800)
      const completeTimer = setTimeout(onTransitionComplete, 1600)

      return () => {
        clearTimeout(slideTimer)
        clearTimeout(completeTimer)
        setShouldSlideUp(false)
      }
    }
  }, [isTransitioning, onTransitionComplete])

  if (!isTransitioning) return null

  return createPortal(
    <LazyMotion features={domAnimation}>
      <m.div
        initial={{ opacity: 0, y: 0 }}
        animate={{ opacity: 1, y: shouldSlideUp ? '-100%' : 0 }}
        transition={{
          opacity: { duration: 0.1 },
          y: { duration: 0.8, ease: [0.43, 0.13, 0.23, 0.96] },
        }}
        className="fixed inset-0 bg-neutral-900 flex items-center justify-center z-50"
      >
        <span className="text-white text-xl font-semibold lowercase">
          {pageName}.
        </span>
      </m.div>
    </LazyMotion>,
    document.body
  )
}

export default PageTransition
